import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { ShareRequestQueryParams, ShareRequestsResponse } from '../../../../shared/types/routes/sbomShare';

const DEFAULT_REFETCH_INTERVAL = 1000 * 10; // Poll every 10 seconds

/**
 * Function to fetch all share requests created by the caller's organization,
 * with optional project filter
 */
function fetchShareRequests(projectLocator?: string) {
  const url = '/api/v1/share-requests';
  const params: ShareRequestQueryParams = {};

  if (projectLocator) {
    params.projectLocator = nuc(projectLocator);
  }

  return get<ShareRequestsResponse>(url, false, params);
}

/**
 * Query key for caching and invalidation
 */
export const getShareRequestsQueryKey = (projectLocator: string) =>
  ['sbomShare', 'shareRequests', projectLocator];

/**
 * Hook to fetch all share requests with optional project filter
 */
export default function useGetShareRequests(projectLocator: string) {
  return useQuery<ShareRequestsResponse>({
    queryKey: getShareRequestsQueryKey(projectLocator),
    queryFn: () => fetchShareRequests(projectLocator),
    refetchInterval: DEFAULT_REFETCH_INTERVAL,
  });
}
